import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from '../../../shared/services/validation.service';
import { NumberModel } from '../../../model/user/number.model';
import { SessionService } from '../../../shared/services/session.service';
import { MaskUtil } from '../../../shared/utils/star-masking-util';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserDto } from '../../../model/user/user-dto';
import { NgOtpInputComponent } from 'ng-otp-input/lib/components/ng-otp-input/ng-otp-input.component';
import { TextService } from '../../../shared/services/text.service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { Login } from "../../../model/netmera-events/login";
import { Error } from "../../../model/netmera-events/error";

@Component({
  selector: 'pa-otp-entry',
  templateUrl: './otp-entry.component.html',
  styleUrls: ['./otp-entry.component.scss']
})
export class OtpEntryComponent implements OnInit {
  numberModel: NumberModel;
  userDto: UserDto;
  phoneNumber: string;
  errorMessage: string;
  deadline: number;
  submitted = false;
  timerHasEnded = false;
  otpInputId: string;
  textService: TextService;
  sdkInitTexts: Array<SdkInitText>;
  trackingId: string;
  merchantCode: string;
  otpForm = new FormGroup({
    otp: new FormControl('', [Validators.required, Validators.minLength(4)])
  });

  config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    inputStyles: {
      width: '20px',
      height: '20px',
      border: 'solid 2px #000000',
      'border-radius': '10px',
      'margin-right': '36px',
      'font-size': '15px',
      'color': 'transparent',
      'caret-color': 'transparent'
    }
  };

  errorConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    inputStyles: {
      width: '20px',
      height: '20px',
      border: 'solid 2px #dc2121',
      'border-radius': '10px',
      'margin-right': '36px',
      'background': '#dc2121',
      'font-size': '15px',
      'color': 'transparent',
      'caret-color': 'transparent'
    }
  };
  @ViewChild('ngOtpInput', {static: false}) ngOtpInput: NgOtpInputComponent;

  constructor(private router: Router, private route: ActivatedRoute, private validationService: ValidationService, private sessionService: SessionService,
              private changeDetectionRef: ChangeDetectorRef, textService: TextService, private netmeraService: NetmeraService, private login: Login, private error: Error) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
      this.numberModel = new NumberModel();
      this.sessionService.getInitUser(this.trackingId).subscribe(response => {
        if (response != null) {
          this.userDto = response;
          this.sdkInitTexts = response.sdkInitTexts;
          this.numberModel = response.numberModelDTO;
          this.phoneNumber = MaskUtil.MaskingConfiguration(response.msisdn, 3, 6);
          this.merchantCode = response?.requestHeader?.merchant?.merchantCode;
          this.netmeraService.pushEvent(this.login.setEventObject("OtpGirisEkrani", this.merchantCode));
          this.updateTimer();
        }
      }, error => {
        this.router.navigate(['/result/error', this.trackingId]);
      });
    });
  }

  checkOtp() {
    this.submitted = true;
    if (this.otpForm.invalid) {
      return;
    }
    this.numberModel.partOfOne = this.otpForm.value.otp;
    this.validationService.checkOtp(this.numberModel, this.trackingId).subscribe(response => {
      if (response.numberModel.pinSuspend) {
        this.ngOtpInput.config = this.errorConfig;
        this.numberModel = response.numberModel;
        this.errorMessage = "Giriş yapabilmeniz için tekrar doğrulama kodu almanız gerekmektedir.";
        this.formReset();
        this.otpInputsDisableOrEnable();
      } else {
        this.netmeraService.pushEvent(this.login.setEventObject("OtpBasarili", this.merchantCode));
        this.router.navigate(['/route', this.trackingId]);
      }
    }, error => {
      this.netmeraService.pushEvent(this.login.setEventObject("OtpBasarisiz", this.merchantCode));
      this.netmeraService.pushEvent(this.error.setEventObject("OtpBasarisiz", this.merchantCode));
      if (error.status == 422) {
        this.ngOtpInput.config = this.errorConfig;
        this.formReset();
        this.errorMessage = error.error.message;
      } else {
        this.router.navigate(['/result/error', this.trackingId]);
      }
    });
  }

  sendOtpAgain(): void {
    if (this.userDto.msisdn) {
      this.validationService.checkPhoneNumber(this.userDto.msisdn, this.trackingId).subscribe(
        response => {
          this.updateTimer();
          this.ngOtpInput.config = this.config;
          this.otpInputsDisableOrEnable();
        },
        error => {
          if (error.status == 422) {
            this.errorMessage = error.error.message;
          } else {
            this.router.navigate(['/result/error', this.trackingId]);
          }
        }
      );
    }
  }

  addOrDeleteCss(event: any) {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    if (event.keyCode == 8 || event.keyCode == 46) {
      this.changeCssRemoveInput(event.srcElement.id, isIEOrEdge);
    }
    if ((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode == 0) {
      this.changeCssAddInput(event.srcElement.id, isIEOrEdge);
    }
  }

  onOtpChange(event: string) {
    this.otpForm.patchValue({otp: event});
    if(this.errorMessage) {
      this.errorMessage = null;
      this.ngOtpInput.config = this.config;
      const firstInput = 'otp_0_' + this.ngOtpInput.componentKey;
      (document.querySelector('#' + firstInput) as HTMLElement).focus();
    }
  }

  changeCssAddInput(otpValue: string, isIEOrEdge: boolean) {
    this.otpInputId = otpValue;
    if (this.otpInputId) {
      (document.querySelector('#' + this.otpInputId) as HTMLElement).style.background = 'black';
      (document.querySelector('#' + this.otpInputId) as HTMLElement).style.color = 'black';
      let style = document.createElement('style');
      style.id = '#' + this.otpInputId;
      style.innerHTML = '::selection {color: black !important}';
      if (isIEOrEdge) {
        document.head.appendChild(style);
      } else {
        document.head.append(style);
      }
    }
  }

  changeCssRemoveInput(otpValue: string, isIEOrEdge: boolean) {
    this.otpInputId = otpValue;
    if (this.otpInputId) {
      (document.querySelector('#' + this.otpInputId) as HTMLElement).style.background = 'white';
      (document.querySelector('#' + this.otpInputId) as HTMLElement).style.color = 'white';
      (document.querySelector('#' + this.otpInputId) as HTMLElement).style.borderColor = 'black';
      let style = document.createElement('style');
      style.id = '#' + this.otpInputId;
      style.innerHTML = '::selection {background-color: transparent;}';
      if (isIEOrEdge) {
        document.head.appendChild(style);
      } else {
        document.head.append(style);
      }
    }
  }

  updateTimer(): void {
    this.submitted = false;
    this.numberModel.pinSuspend = false;
    this.errorMessage = null;
    this.timerHasEnded = false;
    this.deadline = Date.now() + 1000 * 60 * (this.numberModel.otpExpMin / 60);
  }

  stop() {
    this.timerHasEnded = true;
    this.changeDetectionRef.detectChanges();
  }

  formReset() {
    this.submitted = false;
    this.ngOtpInput.otpForm = new FormGroup({
      ctrl_0: new FormControl(null),
      ctrl_1: new FormControl(null),
      ctrl_2: new FormControl(null),
      ctrl_3: new FormControl(null)
    });
  }

  otpInputsDisableOrEnable() {
    if (this.numberModel.pinSuspend) {
      for (let i = 0; i < 4; i++) {
        this.ngOtpInput.otpForm.controls['ctrl_' + i].disable();
      }
    } else {
      for (let i = 0; i < 4; i++) {
        this.ngOtpInput.otpForm.controls['ctrl_' + i].enable();
      }
    }
  }

  messageState(value: any) {
    this.errorMessage = value;
    this.ngOtpInput.config = this.config;
    const firstInput = 'otp_0_' + this.ngOtpInput.componentKey;
    (document.querySelector('#' + firstInput) as HTMLElement).focus();
  }

}
